// @flow
import JQueryView, { on } from '../../../common/JQueryView';
import { VOTE_DELEGATE } from '../../../../models/companies/stockholder_meetings/Vote';

declare var $: any;

export default class EditView extends JQueryView {
  constructor() {
    super('.companies.stockholder_meetings.delegates.edit');
  }

  @on({
    event: 'click',
    selector: '.resolution .form-check-input.radio_buttons',
  })
  hideExclusionInput(event: any) {
    const value = $(event.target)
      .parents('.resolution-edit-row')
      .find('.resolution .form-check-input.radio_buttons:checked')
      .val();
    const $input = $(event.target)
      .parents('.resolution-edit-row')
      .find('.exclusion .form-check-input.boolean.optional');
    const $exclusion = $(event.target)
      .parents('.resolution-edit-row')
      .find('.exclusion');
    if (value == VOTE_DELEGATE) {
      $input.prop('checked', false);
      $exclusion.addClass('d-none');
    } else {
      $exclusion.removeClass('d-none');
    }
  }
}
